import { render, staticRenderFns } from "./BimMake.vue?vue&type=template&id=4d69846f&scoped=true"
import script from "./BimMake.vue?vue&type=script&lang=js"
export * from "./BimMake.vue?vue&type=script&lang=js"
import style0 from "./BimMake.vue?vue&type=style&index=0&id=4d69846f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d69846f",
  null
  
)

export default component.exports